import { PropsWithChildren } from 'react';
import { UserModalLayout } from '@features/components/UserModalLayout';
import { EmployeeComposed } from '@/api/apis/resources';
import { UserHeader } from './components/UserHeader';
import { UserInfo } from './components/UserInfo';

type UserInfoModalProps = {
  user?: EmployeeComposed;
};

export const UserInfoModal = ({ user, children }: PropsWithChildren<UserInfoModalProps>) => {
  return (
    <UserModalLayout trigger={children}>
      {user && (
        <>
          <UserHeader user={user} />
          <UserInfo user={user} />
        </>
      )}
    </UserModalLayout>
  );
};
